import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  SimpleDialogComponent,
  SimpleDialogOptions,
  SimpleDialogResponse,
} from '../components/simple-dialog/simple-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class SimpleDialogService {
  constructor(private matDialog: MatDialog) {
  }

  createDialog(data: SimpleDialogOptions): MatDialogRef<SimpleDialogComponent, SimpleDialogResponse> {
    return this.matDialog.open<SimpleDialogComponent, SimpleDialogOptions, SimpleDialogResponse>(
      SimpleDialogComponent,
      { data },
    );
  }
}
